import { Box, ContentBlock, Hidden } from 'braid-design-system';
import React from 'react';

import DesktopMessage from './components/DesktopMessage/DesktopMessage';
import MobileMessage from './components/MobileMessage/MobileMessage';

const SellingAFranchise = () => (
  <Box paddingY={['none', 'none', 'xlarge']}>
    <Box
      paddingY={['none', 'none', 'large']}
      style={{ backgroundColor: '#a4caec' }}
    >
      <ContentBlock>
        <Box
          paddingX={['medium', 'xxlarge', 'xxlarge']}
          paddingY="large"
          style={{ position: 'relative' }}
        >
          <Hidden below="tablet">
            <DesktopMessage />
          </Hidden>
          <Hidden above="mobile">
            <MobileMessage />
          </Hidden>
        </Box>
      </ContentBlock>
    </Box>
  </Box>
);

export default SellingAFranchise;
